import { RoutesEnum } from './routes.enum';
import { TrackingEvent } from './tracking-events.enum';

export const TrackedRoutesMap: Map<RoutesEnum, TrackingEvent> = new Map([
    [RoutesEnum.DASHBOARD, TrackingEvent.VIEWED_PAGE_DAHSBOARD],
    [RoutesEnum.PATHS, TrackingEvent.VIEWED_PAGE_PATHS],
    [RoutesEnum.DATA, TrackingEvent.VIEWED_PAGE_DATA],
    [RoutesEnum.REPORTS, TrackingEvent.VIEWED_PAGE_REPORTS],
    [RoutesEnum.VISITS, TrackingEvent.VIEWED_PAGE_VISITS],
    [RoutesEnum.ACCOUNT, TrackingEvent.VIEWED_PAGE_SETTINGS_ACCOUNT],
    [RoutesEnum.DEVICES, TrackingEvent.VIEWED_PAGE_SETTINGS_DEVICES],
    [
        RoutesEnum.TERMS_AND_CONDITIONS,
        TrackingEvent.VIEWED_PAGE_SETTINGS_TERMS_AND_CONDITIONS,
    ],
    [
        RoutesEnum.PRIVACY_POLICY,
        TrackingEvent.VIEWED_PAGE_SETTINGS_PRIVACY_POLICY,
    ],
    [RoutesEnum.SUPPORT, TrackingEvent.VIEWED_PAGE_SETTINGS_SUPPORT],
    [RoutesEnum.LOGIN, TrackingEvent.VIEWED_PAGE_LOGIN],
]);
